<div
    class="drag-indicator"
    data-testid="drag-preview">
    {{ text }}
</div>
